export const Messages  = {
    MEME_FOR_FRIENDS: 'MEME_FOR_FRIENDS',
    MEME_PUBLIC: 'MEME_PUBLIC',
    MEME_PRIVATE: 'MEME_PRIVATE',

    SHOW_FIRST: 'SHOW_FIRST'
};